import React from 'react';
import { Modal } from './Modal';

/*
 * RecordModal — a Drawer-shaped record (kicker, badge, title, sub, footer)
 * shown as a centered dialog. Lets a panel move off the page edge without
 * rewriting the body it already renders.
 */

export const RecordModal: React.FC<{
  onClose: () => void;
  kicker?: React.ReactNode;
  badge?: React.ReactNode;
  title: React.ReactNode;
  sub?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}> = ({ onClose, kicker, badge, title, sub, footer, children }) => (
  <Modal size="dialog" onClose={onClose} context={kicker} badge={badge} footer={footer}>
    <h2 className="m-0 text-[24px] font-bold leading-[31px] tracking-[-0.015em] text-ink">{title}</h2>
    {sub && <p className="m-0 mt-2 text-[14px] leading-[23px] text-ink-muted">{sub}</p>}
    <div className="mt-6">{children}</div>
  </Modal>
);
